<header class="header" appClickOutside (clickOutside)="closeAllMenus()" menuClass="js-header-menu">
  <div class="header__content">
    <!-- TODO: apps launcher - the redesign shows the 3x3 dot grid but no target
         is defined for it yet, so the button is intentionally inert. -->
    @if (showAppsLauncher()) {
      <button type="button" class="apps-launcher" (click)="onAppsLauncherClick()">
        @for (dot of appsLauncherDots; track $index) {
          <span class="apps-launcher__dot"></span>
        }
      </button>
    }

    @if (!isActive('/')) {
      <a class="logo" [routerLink]="['/']" menuNavItem>
        <img class="logo__img" [src]="'assets/img/common/logo-white-' + providerWebsiteId + '.svg'" alt="" />
      </a>
    } @else {
      <a class="logo" [routerLink]="['/']" [queryParams]="{ r: 1 }" menuNavItem>
        <img class="logo__img" [src]="'assets/img/common/logo-white-' + providerWebsiteId + '.svg'" alt="" />
      </a>
    }

    <nav class="nav">
      <a class="nav__link" [routerLink]="['/']" menuNavItem>
        <svg-icon class="nav__icon nav__icon--jobs" src="assets/icons/header-2-jobs.svg"></svg-icon>
        <span class="nav__text">{{ 'label.Announcements' | translate }}</span>
      </a>
      <a class="nav__link" [routerLink]="['/cvbox']" menuNavItem>
        <svg-icon class="nav__icon nav__icon--box" src="assets/icons/header-2-cv-box.svg"></svg-icon>
        <span class="nav__text">{{ 'label.CvBoxes' | translate }}</span>
      </a>
      <a class="nav__link favourite-box" [routerLink]="['/announcement/favorites']" menuNavItem>
        <svg-icon class="nav__icon nav__icon--heart" [src]="favoritesIcon()"></svg-icon>
        <span class="nav__text">{{ 'label.Favorites' | translate }}</span>
        @if (((favCount$ | async) ?? 0) > 0) {
          <span class="nav__count">{{ favCount$ | async }}</span>
        }
      </a>
      <a class="nav__link" [routerLink]="['/jobseeker/subscription']" menuNavItem>
        <svg-icon class="nav__icon nav__icon--mail" src="assets/icons/header-2-mail.svg"></svg-icon>
        <span class="nav__text">{{ 'label.Subscribe' | translate }}</span>
      </a>
      <a class="nav__link" [routerLink]="['/jobseeker/applies/invitations']" menuNavItem>
        <svg-icon class="nav__icon nav__icon--invite" src="assets/icons/header-2-invite.svg"></svg-icon>
        <span class="nav__text">{{ 'label.Invite' | translate }}</span>
      </a>
      @if (blogEnabled$ | async) {
        <a class="nav__link" [href]="blogUrl$ | async" target="_blank" rel="noopener noreferrer" menuNavItem>
          <span class="nav__text">{{ 'label.Blog' | translate }}</span>
        </a>
      }
    </nav>

    <span class="header__spacer"></span>

    <div class="account">
      <button type="button" class="account__toggle" (click)="toggleAccountMenu()">
        <span class="account__info">
          <span class="account__name">{{ user?.name }}</span>
          @if (user?.userEmail) {
            <span class="account__email">{{ user.userEmail }}</span>
          }
        </span>
        <span class="avatar">{{ initials }}</span>
        <svg-icon class="caret" src="assets/icons/header-2-caret-down.svg"></svg-icon>
      </button>

      @if (isAccountMenuOpen) {
        <div class="account__menu">
          @if (languages?.length) {
            <div class="account__languages">
              <!-- TODO: the design uses three letter codes (GEO / ENG), the
                   existing label.lang-short-* translations return two letters. -->
              @for (language of languages; track language) {
                <button
                  type="button"
                  class="account__language"
                  [class.account__language--active]="language === currentLanguage"
                  (click)="selectLanguage(language)"
                >
                  {{ ('label.lang-short-' + language) | translate }}
                </button>
              }
            </div>
          }
          <a class="account__menu-item" [routerLink]="['/jobseeker/profile']" menuNavItem>{{ 'label.Profile' | translate }}</a>
          <a class="account__menu-item" [routerLink]="['/jobseeker/applies']" menuNavItem>{{ 'label.Applications' | translate }}</a>
          <a class="account__menu-item" [routerLink]="['/jobseeker/settings']" menuNavItem>{{ 'label.MySettings' | translate }}</a>
          <button type="button" class="account__menu-item" (click)="onSignOutClick()">{{ 'label.SignOut' | translate }}</button>
        </div>
      }
    </div>

    <button type="button" class="menu-toggle" (click)="toggleBurgerMenu()">
      <svg-icon class="menu-toggle__icon" src="assets/icons/header-2-menu.svg"></svg-icon>
    </button>
  </div>

  @if (isBurgerMenuOpen) {
    <div class="burger-menu">
      <div class="burger-menu__content">
        <div class="burger-menu__user">
          <span class="avatar avatar--large">{{ initials }}</span>
          <div class="burger-menu__user-info">
            <div class="burger-menu__user-name">{{ user?.name }}</div>
            @if (user?.userEmail) {
              <div class="burger-menu__user-email">{{ user.userEmail }}</div>
            }
          </div>
        </div>

        <a class="burger-menu__row" [routerLink]="['/']" menuNavItem>
          <svg-icon class="burger-menu__icon burger-menu__icon--jobs" src="assets/icons/header-2-jobs.svg"></svg-icon>
          <span class="burger-menu__text">{{ 'label.Announcements' | translate }}</span>
        </a>
        <a class="burger-menu__row" [routerLink]="['/cvbox']" menuNavItem>
          <svg-icon class="burger-menu__icon burger-menu__icon--box" src="assets/icons/header-2-cv-box.svg"></svg-icon>
          <span class="burger-menu__text">{{ 'label.CvBoxes' | translate }}</span>
        </a>
        <a class="burger-menu__row" [routerLink]="['/announcement/favorites']" menuNavItem>
          <svg-icon class="burger-menu__icon burger-menu__icon--heart" [src]="favoritesIcon()"></svg-icon>
          <span class="burger-menu__text">{{ 'label.Favorites' | translate }}</span>
          @if (((favCount$ | async) ?? 0) > 0) {
            <span class="burger-menu__count">{{ favCount$ | async }}</span>
          }
        </a>
        <a class="burger-menu__row" [routerLink]="['/jobseeker/subscription']" menuNavItem>
          <svg-icon class="burger-menu__icon burger-menu__icon--mail" src="assets/icons/header-2-mail.svg"></svg-icon>
          <span class="burger-menu__text">{{ 'label.Subscribe' | translate }}</span>
        </a>
        <a class="burger-menu__row" [routerLink]="['/jobseeker/applies/invitations']" menuNavItem>
          <svg-icon class="burger-menu__icon burger-menu__icon--invite" src="assets/icons/header-2-invite.svg"></svg-icon>
          <span class="burger-menu__text">{{ 'label.Invite' | translate }}</span>
        </a>
        @if (blogEnabled$ | async) {
          <a class="burger-menu__row" [href]="blogUrl$ | async" target="_blank" rel="noopener noreferrer" menuNavItem>
            <span class="burger-menu__text">{{ 'label.Blog' | translate }}</span>
          </a>
        }

        <div class="burger-menu__divider"></div>

        <a class="burger-menu__row" [routerLink]="['/jobseeker/profile']" menuNavItem>
          <span class="burger-menu__text">{{ 'label.Profile' | translate }}</span>
        </a>
        <a class="burger-menu__row" [routerLink]="['/jobseeker/applies']" menuNavItem>
          <span class="burger-menu__text">{{ 'label.Applications' | translate }}</span>
        </a>
        <a class="burger-menu__row" [routerLink]="['/jobseeker/settings']" menuNavItem>
          <span class="burger-menu__text">{{ 'label.MySettings' | translate }}</span>
        </a>

        @if (languages?.length) {
          <div class="burger-menu__row burger-menu__row--languages">
            @for (language of languages; track language) {
              <button
                type="button"
                class="burger-menu__language"
                [class.burger-menu__language--active]="language === currentLanguage"
                (click)="selectLanguage(language)"
              >
                {{ ('label.lang-short-' + language) | translate }}
              </button>
            }
          </div>
        }

        <button type="button" class="burger-menu__row burger-menu__row--button" (click)="onSignOutClick()">
          <span class="burger-menu__text">{{ 'label.SignOut' | translate }}</span>
        </button>
      </div>
    </div>
  }
</header>
